"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _StatusMessageDto = _interopRequireDefault(require("../model/StatusMessageDto"));

var _SurgicalCaseDto = _interopRequireDefault(require("../model/SurgicalCaseDto"));

var _SurgicalCaseEntityDto = _interopRequireDefault(require("../model/SurgicalCaseEntityDto"));

var _SurgicalCaseMetadataDto = _interopRequireDefault(require("../model/SurgicalCaseMetadataDto"));

var _SurgicalCaseStateDto = _interopRequireDefault(require("../model/SurgicalCaseStateDto"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* SurgicalCase service.
* @module 2/SurgicalCaseApi
* @version 5.0.7
*/
var SurgicalCaseApi = /*#__PURE__*/function () {
  /**
  * Constructs a new SurgicalCaseApi. 
  * @alias module:2/SurgicalCaseApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function SurgicalCaseApi(apiClient) {
    _classCallCheck(this, SurgicalCaseApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Gets the list of surgical cases. Note: The users/applications will only retrieve the surgical cases of the  branch(es) that he/it is responsible for.  In detail: On creation of a branch via POST /branches, the `externalReference` field is generated by the system.  On creation of a surgical case via POST /surgicalcases the content of `externalReference` is used to fill  the field `branchNumber` of the surgical case. On GET /surgicalcases the surgical cases returned are  limited to the branches which the requestee is allowed to access. (Requires: Roles -> RH.SC.ReadList, RH.SC.L, RH.SC.Admin).
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/SurgicalCaseEntityDto>} and HTTP response
   */


  _createClass(SurgicalCaseApi, [{
    key: "surgicalcasesGetWithHttpInfo",
    value: function surgicalcasesGetWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_SurgicalCaseEntityDto["default"]];
      return this.apiClient.callApi('/surgicalcases', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets the list of surgical cases. Note: The users/applications will only retrieve the surgical cases of the  branch(es) that he/it is responsible for.  In detail: On creation of a branch via POST /branches, the `externalReference` field is generated by the system.  On creation of a surgical case via POST /surgicalcases the content of `externalReference` is used to fill  the field `branchNumber` of the surgical case. On GET /surgicalcases the surgical cases returned are  limited to the branches which the requestee is allowed to access. (Requires: Roles -> RH.SC.ReadList, RH.SC.L, RH.SC.Admin).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/SurgicalCaseEntityDto>}
     */

  }, {
    key: "surgicalcasesGet",
    value: function surgicalcasesGet() {
      return this.surgicalcasesGetWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Gets the surgical case. (Requires: Roles -> RH.SC.Read, RH.SC.R, RH.SC.L, RH.SC.Admin).
     * @param {String} id The surgical case identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SurgicalCaseEntityDto} and HTTP response
     */

  }, {
    key: "surgicalcasesIdGetWithHttpInfo",
    value: function surgicalcasesIdGetWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling surgicalcasesIdGet");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _SurgicalCaseEntityDto["default"];
      return this.apiClient.callApi('/surgicalcases/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Gets the surgical case. (Requires: Roles -> RH.SC.Read, RH.SC.R, RH.SC.L, RH.SC.Admin).
     * @param {String} id The surgical case identifier.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SurgicalCaseEntityDto}
     */

  }, {
    key: "surgicalcasesIdGet",
    value: function surgicalcasesIdGet(id) {
      return this.surgicalcasesIdGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Updates the surgical case. (Requires: Roles -> RH.SC.Update, RH.SC.U, RH.SC.Admin).
     * @param {String} id The surgical case identifier.
     * @param {module:model/SurgicalCaseDto} surgicalCaseDto The surgical case.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SurgicalCaseMetadataDto} and HTTP response
     */

  }, {
    key: "surgicalcasesIdPutWithHttpInfo",
    value: function surgicalcasesIdPutWithHttpInfo(id, surgicalCaseDto) {
      var postBody = surgicalCaseDto; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling surgicalcasesIdPut");
      } // verify the required parameter 'surgicalCaseDto' is set


      if (surgicalCaseDto === undefined || surgicalCaseDto === null) {
        throw new Error("Missing the required parameter 'surgicalCaseDto' when calling surgicalcasesIdPut");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _SurgicalCaseMetadataDto["default"];
      return this.apiClient.callApi('/surgicalcases/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Updates the surgical case. (Requires: Roles -> RH.SC.Update, RH.SC.U, RH.SC.Admin).
     * @param {String} id The surgical case identifier.
     * @param {module:model/SurgicalCaseDto} surgicalCaseDto The surgical case.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SurgicalCaseMetadataDto}
     */

  }, {
    key: "surgicalcasesIdPut",
    value: function surgicalcasesIdPut(id, surgicalCaseDto) {
      return this.surgicalcasesIdPutWithHttpInfo(id, surgicalCaseDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Updates the state of the surgical case. (Requires: Roles -> RH.SC.State.Update, RH.SC.U, RH.SC.State.U, RH.SC.Admin).
     * @param {String} id The surgical case identifier.
     * @param {module:model/SurgicalCaseStateDto} surgicalCaseStateDto State of the surgical case.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SurgicalCaseMetadataDto} and HTTP response
     */

  }, {
    key: "surgicalcasesIdStatePutWithHttpInfo",
    value: function surgicalcasesIdStatePutWithHttpInfo(id, surgicalCaseStateDto) {
      var postBody = surgicalCaseStateDto; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling surgicalcasesIdStatePut");
      } // verify the required parameter 'surgicalCaseStateDto' is set


      if (surgicalCaseStateDto === undefined || surgicalCaseStateDto === null) {
        throw new Error("Missing the required parameter 'surgicalCaseStateDto' when calling surgicalcasesIdStatePut");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _SurgicalCaseMetadataDto["default"];
      return this.apiClient.callApi('/surgicalcases/{id}/state', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Updates the state of the surgical case. (Requires: Roles -> RH.SC.State.Update, RH.SC.U, RH.SC.State.U, RH.SC.Admin).
     * @param {String} id The surgical case identifier.
     * @param {module:model/SurgicalCaseStateDto} surgicalCaseStateDto State of the surgical case.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SurgicalCaseMetadataDto}
     */

  }, {
    key: "surgicalcasesIdStatePut",
    value: function surgicalcasesIdStatePut(id, surgicalCaseStateDto) {
      return this.surgicalcasesIdStatePutWithHttpInfo(id, surgicalCaseStateDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Creates the surgical case. (Requires: Roles -> RH.SC.Create, RH.SC.C, RH.SC.Admin).
     * @param {module:model/SurgicalCaseDto} surgicalCaseDto The surgical case.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/SurgicalCaseMetadataDto} and HTTP response
     */

  }, {
    key: "surgicalcasesPostWithHttpInfo",
    value: function surgicalcasesPostWithHttpInfo(surgicalCaseDto) {
      var postBody = surgicalCaseDto; // verify the required parameter 'surgicalCaseDto' is set

      if (surgicalCaseDto === undefined || surgicalCaseDto === null) {
        throw new Error("Missing the required parameter 'surgicalCaseDto' when calling surgicalcasesPost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['Bearer'];
      var contentTypes = ['application/json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = _SurgicalCaseMetadataDto["default"];
      return this.apiClient.callApi('/surgicalcases', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Creates the surgical case. (Requires: Roles -> RH.SC.Create, RH.SC.C, RH.SC.Admin).
     * @param {module:model/SurgicalCaseDto} surgicalCaseDto The surgical case.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/SurgicalCaseMetadataDto}
     */

  }, {
    key: "surgicalcasesPost",
    value: function surgicalcasesPost(surgicalCaseDto) {
      return this.surgicalcasesPostWithHttpInfo(surgicalCaseDto).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return SurgicalCaseApi;
}();

exports["default"] = SurgicalCaseApi;